import { useMutation } from '@apollo/client';
import { gql } from '@/__generated__';

export const GenerateUsernames = gql(`
  mutation GenerateUsernames {
    generatePossibleUsernames
  }
`);

export const useGenerateUsernames = () => {
  const [generateUsernamesMutation, result] = useMutation(GenerateUsernames, {
    update(cache, { data }) {
      if (data?.generatePossibleUsernames) {
        cache.modify({
          fields: {
            me(existing, { readField }) {
              return {
                id: readField('id', existing),
                xComHandle: readField('xComHandle', existing),
                protectedFields: {
                  possibleUsernames: data.generatePossibleUsernames,
                },
              };
            },
          },
        });
      }
    },
  });

  const generateUsernames = () => {
    return generateUsernamesMutation();
  };

  return [generateUsernames, result] as const;
};
